export function setPosTop() {
  if (!document.body.classList.contains('is-set-top')) {
    const scTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop
    document.body.dataset.posTop = scTop
    document.body.classList.add(`is-set-top`)
  }
}
export function resetPosTop() {
  if (document.body.classList.contains('is-set-top')) {
    const currentTop = document.body.dataset.posTop
    window.scrollTo(0, currentTop)
    document.body.removeAttribute('data-pos-top')
    document.body.classList.remove(`is-set-top`)
  }
}
